export default __webpack_public_path__ + "static/media/beetle1.db424ac9.jpg";